function SLR_Contract(_ctr)
{
	// parent element
	var self = this;
	self.ctr = _ctr;
	self.item = {};
	self.action = undefined;
	self.action_callback = undefined;

	self.reset = function() {
		self.item = {
			id: undefined,
			contact_id: undefined,
			str_id: undefined,
			fonction: undefined,
			jours_tournage: 0,
			emissions_episodes: 0,
			banque: 0,
			banque_details: '',
			note: '',
			cachet: 0,
			cachet_total: 0,
			droits_percent: 0,
			droits_total: 0,
			garanties: [],
			deleted: false
		};
	};

	self.save = function()
	{
		// gather data
		var request = new FormData(),
		data = {};

		// build request
		request.append("model", "contract");
		request.append("action", "auto");
		request.append("data", JSON.stringify(self.item));

		// add request to queue
		$.slr.db.add(request, self.callback);
		return false;
	};

	self.create = function(new_str_id)
	{
		// gather data
		self.reset();
		self.action = "create";
		self.item.contact_id = self.ctr.e.el.form.get_contact_id();
		self.item.str_id = new_str_id;
		self.save();
		return false;
	};

	self.rename = function(new_str_id, action_callback)
	{
		self.action = "rename";
		self.action_callback = action_callback;
		self.item.str_id = new_str_id;
		self.save();
		return false;
	}

	self.get = function(contract_id)
	{
		// gather data
		self.reset();
		self.item.id = contract_id;
		var request = new FormData(),
		data = {};

		// build request
		request.append("model", "contract");
		request.append("action", "get");
		request.append("data", JSON.stringify(self.item));

		// add request to queue
		$.slr.db.add(request, self.loaded);
		return false;
	};

	self.loaded = function(x)
	{
		// load contract file
		self.item = x.item;
		self.ctr.load_files();

		// elements list and contract button actions
		var elements_list = self.parse_elements_list(x.elements);
		_ctr.interface.rename_btn.prop("disabled", false);
		_ctr.interface.clipboard_btn.prop("disabled", false);
		_ctr.interface.delete_btn.prop("disabled", elements_list.length);

		// display importable rows
		_ctr.contract_table.load(elements_list);
	};

	self.delete = function(action_callback)
	{
		self.action = "delete";
		self.action_callback = action_callback;
		self.item.deleted = 1;
		self.save();
		return false;
	};

	self.callback = function(x)
	{
		// get the current callback action
		var action = self.action;
		self.action = undefined;

		// created contract
		if (action == "create"){
			if (x == undefined){	// did not work
				self.ctr.interface.select2.val(0).trigger("change");
			} else {
				self.item = x.item;
				self.ctr.created(self.item);
				self.ctr.load_files();
				_ctr.interface.rename_btn.prop("disabled", false);
				_ctr.interface.clipboard_btn.prop("disabled", false);
				_ctr.interface.delete_btn.prop("disabled", false);
			}

			// renamed contract
		} else if (action == "rename"){
			self.action_callback(x);
			self.ctr.e.contractRenamed();

			// deleted contract
		} else if (action == "delete"){
			self.action_callback(x);
			self.ctr.e.contractDeleted();

		} else {
			self.ctr.e.contractChanged();
		}
	};

	self.parse_elements_list = function(elements_list)
	{
		var parsed_elements_list = [];
		elements_list.forEach(function(element, index){
			// all return 1
			if (element.invoice_id != self.ctr.e.el.form.getInvoiceID() && element.type == self.ctr.e.el.form.get_invoice_type()){
				parsed_elements_list.push(element);
			}
		});
		return parsed_elements_list;
	};

	self.init = function()
	{
		self.reset();
		if (self.ctr.find("select[name=contract_id]").val()){
			self.item.id = parseInt(self.ctr.find("select[name=contract_id]").val(), 10);
		}
	}();
}

$.fn.Contract = function(_e)
{
	var _ctr = this;
	_ctr.e = _e;
	_ctr.model = new SLR_Contract(_ctr);
	_ctr.form = _ctr.find("form.contract");
	_ctr.interface = {
		select : _ctr.find("select[name=contract_id]"),
		select2 : undefined,
		contract_files : _ctr.find(".contract-files-cell"),
		contract_notes : _ctr.find(".contract-notes-cell"),
		contract_comment : _ctr.find(".contract-comment-cell"),
		element_files : _ctr.find(".element-files-cell"),
		element_timesheets : _ctr.find(".element-timesheet-cell"),
		action_buttons : _ctr.find(".contract-actions"),
		rename_btn : _ctr.find("button[data-action='rename-contract']"),
		delete_btn : _ctr.find("button[data-action='delete-contract']"),
		clipboard_btn : _ctr.find("button[data-action='copy-contract']"),
		next_tab_btn : _ctr.find("button[data-action='next-tab']")
	};
	_ctr.uploader = {
		contract : undefined,
		element : undefined
	};
	_ctr.contract_table = undefined;
	_ctr.element_files_loaded = false;

	_ctr.changed = function()
	{
		// reset files for now
		_ctr.uploader.contract.reset();
		_ctr.uploader.notes.reset();
		_ctr.find('textarea[name="note"]').prop('disabled', true).val('');

		// disable buttons for now
		_ctr.interface.rename_btn.prop("disabled", true);
		_ctr.interface.delete_btn.prop("disabled", true);
		_ctr.interface.clipboard_btn.prop("disabled", true);

		// action
		if ($(this).val() !== "0" && _ctr.e.el.existing_contracts.indexOf($(this).val()) === -1){
			swal({
				title: "Nouveau contrat?",
				text: "Voulez-vous créer un nouveau contrat avec l'identifiant " + $(this).val() + " ?",
				type: "warning",
				showCancelButton: true,
				confirmButtonClass: "btn-info",
				confirmButtonText: "Oui, créer le contrat",
				cancelButtonText: "Non",
				closeOnConfirm: true,
				closeOnCancel: true
			},
			function(isConfirm) {
				if (isConfirm) {
					var new_str_id = _ctr.find("select[name=contract_id] option:selected").text();
					if (new_str_id == "Pas de contrat (N/D)") {
						new_str_id = _ctr.find("select[name=contract_id] option:selected").val();
					}
					_ctr.model.create(new_str_id);
				} else {
					_ctr.interface.select2.val(0).trigger("change");
				}
			});
		} else if ($(this).val() === "0"){
			_ctr.model.reset();
			_ctr.e.set("contract_id", "NULL");
			_ctr.uploader.contract.reset();
			_ctr.uploader.notes.reset();
			_ctr.contract_table.reset();
			_ctr.interface.action_buttons.attr("aria-hidden", "true");
			_ctr.e.contractUpdated();
		} else {
			var contract_id = parseInt($(this).val(), 10);
			_ctr.interface.action_buttons.attr("aria-hidden", "false");
			_ctr.model.get(contract_id);
			_ctr.e.set("contract_id", contract_id);
			_ctr.e.contractUpdated();
		}
	};

	_ctr.created = function(item)
	{
		// add the option in dropdown
		_ctr.e.el.existing_contracts.push(item.id);
		_ctr.interface.select.find('option[value="' + item.str_id + '"]').remove();
		_ctr.interface.select.append($('<option value="' + item.id + '">' + item.str_id + '</option>').prop("selected", true));
		_ctr.interface.select.change();

		// affect the template
		_ctr.e.el.template.find(".select-plus-new").replaceWith(_ctr.interface.select.clone());
		_ctr.interface.action_buttons.attr("aria-hidden", "false");
		_ctr.interface.rename_btn.prop("disabled", false);
		_ctr.interface.delete_btn.prop("disabled", false);
		_ctr.interface.clipboard_btn.prop("disabled", false);

		// affect other elements
		_ctr.e.contractCreated();
	};

	_ctr.get_id = function() // for uploader
	{
		return _ctr.getContractID();
	};

	_ctr.getContractID = function()
	{
		return _ctr.model.item.id;
	};

	_ctr.load_files = function()
	{
		// load contrat file
		_ctr.uploader.contract.reset();
		_ctr.uploader.notes.reset();

		$.ajax("/facture/contract_files/" + _ctr.get_id() + "/" + "491", {
			data: {},
			dataType: 'html',
			complete: function(x) {
				var response = $('<html></html>').html(x.responseText);

				// Contract file
				_ctr.interface.contract_files.replaceWith(response.find(".contract-files-cell"));
				_ctr.interface.contract_files = _ctr.find(".contract-files-cell");
				_ctr.init_contract_uploader();

				// Contract notes
				_ctr.interface.contract_notes.replaceWith(response.find(".contract-notes-cell"));
				_ctr.interface.contract_notes = _ctr.find(".contract-notes-cell");
				_ctr.init_notes_uploader();

				// Contract comment
				if (response.find(".contract-comment-cell").length) {
					_ctr.interface.contract_comment.replaceWith(response.find(".contract-comment-cell"));
					_ctr.interface.contract_comment = _ctr.find(".contract-comment-cell");
					_ctr.init_comment_field();
				}
			}
		});
	};

	_ctr.load_element_files = function()
	{
		// load element files
		if (!_ctr.element_files_loaded){ // only once on load or when ID is assigned
			$.ajax("/facture/element_files/" + _ctr.e.getElementID(), {
				data: {},
				dataType: 'html',
				complete: function(x) {
					_ctr.interface.element_files.replaceWith($(x.responseText).filter('.element-files-cell'));
					_ctr.interface.element_files = _ctr.find(".element-files-cell");
					_ctr.interface.element_timesheets.replaceWith($(x.responseText).filter('.element-timesheet-cell'));
					_ctr.interface.element_timesheets = _ctr.find(".element-timesheet-cell");
					_ctr.init_element_uploader();
					_ctr.init_file_draggables();
					_ctr.interface.element_files.fadeIn("fast");
					_ctr.interface.element_timesheets.fadeIn("fast");
				}
			});
			_ctr.element_files_loaded = true;
		}
	};

	_ctr.reloadOthers = function(source_contract)
	{
		// load inside if right id
		if (_ctr.model.item.id == source_contract.get_id() && _ctr != source_contract){
			_ctr.interface.contract_files.load("/facture/contract_files/" + source_contract.get_id(), {}, function(){
				_ctr.init_contract_uploader();
				_ctr.init_contract_draggables();
				_ctr.interface.contract_files.fadeIn("fast");
			});
			_ctr.interface.contract_notes.load("/facture/contract_notes/" + source_contract.get_id(), {}, function(){
				_ctr.init_notes_uploader();
				_ctr.init_contract_draggables();
				_ctr.interface.contract_notes.fadeIn("fast");
			});
		}
	};

	_ctr.init_contract_uploader = function()
	{
		// file uploaders
		_ctr.uploader.contract = _ctr.find(".contract-files-upload").Uploader({
			parent: _ctr,
			model : 'contract',
			type: 'file',
			id : _ctr.get_id(),
			str_id : _ctr.model.item.str_id,
			multiple: true,
			callback : function(){
				_ctr.e.el.reloadContractFiles(_ctr);
			}
		});
		_ctr.init_contract_draggables()
	};

	_ctr.init_notes_uploader = function()
	{
		// file uploaders
		_ctr.uploader.notes = _ctr.find(".contract-notes-upload").Uploader({
			parent: _ctr,
			model : 'contract',
			type: 'note',
			id : _ctr.get_id(),
			str_id : _ctr.model.item.str_id,
			multiple: true,
			callback : function(){
				_ctr.e.el.reloadContractNotes(_ctr);
			}
		});
		_ctr.init_contract_draggables()
	};

	_ctr.init_element_uploader = function()
	{
		if (_ctr.e.getElementID()){
			// real element uploader with element id
			_ctr.uploader.element = _ctr.find(".element-file-upload").Uploader({
				parent: _ctr,
				model : 'element',
				id : _ctr.e.getElementID(),
				multiple: true,
				type: 'file',
			});
			_ctr.uploader.timesheet = _ctr.find(".element-timesheet-upload").Uploader({
				parent: _ctr,
				model : 'element',
				id : _ctr.e.getElementID(),
				multiple: true,
				type: 'timesheet',
			});
		} else {
			// dummy and disabled element uploader just for looks
			_ctr.uploader.element = _ctr.find(".element-file-upload").Uploader({
				parent: _ctr,
				model : 'element',
				id : 0,
				multiple: false,
				type: 'file',
			});
			_ctr.uploader.timesheet = _ctr.find(".element-timesheet-upload").Uploader({
				parent: _ctr,
				model : 'element',
				id : 0,
				multiple: false,
				type: 'timesheet',
			});
			_ctr.uploader.element.disable();
			_ctr.uploader.timesheet.disable();
		}
	};

	_ctr.init_file_draggables = function() {
		_ctr.find('.element-files-cell, .element-timesheet-cell').each(function() {
			let $cell = $(this),
			type = $(this).hasClass('element-timesheet-cell') ? 'timesheet' : 'file'
			if (!$cell.data('is-droppable-initialized')) {
				$cell.droppable({
					accept: 'a',
					drop: function(event, ui) {
						$.ajax({
							url: '/fichier/api/',
							type: 'POST',
							data: {
								object_type: 'file',
								file_action: 'element_' + type,
								element_id: _ctr.e.getElementID(),
								file_id: ui.draggable.data('value'),
								attachment_id: ui.draggable.data('attachment'),
							},
							dataType: 'json',
							success: function (response) {
								let $newFile = $('<div class="file-holder" data-file-id="' + ui.draggable.data('attachment') + '"><label class="mb-0"><a href="' + ui.draggable.attr('href') + '" target="_blank">' + ui.draggable.text() + '</a></label><button class="btn btn-sm btn-link btn-action-upload-delete"><span class="material-symbols-outlined">delete</span></button></div>'),
								attachment_id = ui.draggable.data('attachment')
								$newFile.find('.btn-action-upload-delete').on('click', function() {
									swal({
										title: "Êtes-vous certain?",
										text: "Voulez-vous vraiment supprimer ce fichier?",
										type: "warning",
										showCancelButton: true,
										confirmButtonClass: "btn-danger",
										confirmButtonText: "Oui, supprimer le fichier",
										cancelButtonText: "Non",
										closeOnConfirm: true,
										closeOnCancel: true
									},
									function(isConfirm) {
										if (isConfirm) {
											$newFile.fadeOut("fast");
											var request = new FormData();
											request.append("model", 'element');
											request.append("type", type);
											request.append("action", "delete_file");
											request.append("data", JSON.stringify({
												id : _ctr.e.getElementID(),
												file_id : attachment_id,
												index: 0,
											}));
											$.slr.db.add(request);
										}
									});
									return false;
								})
								$cell.find('.files').append($newFile)
							},
						})
					},
				});
				$cell.data('is-droppable-initialized', 1)
			}
		})
	}

	_ctr.init_contract_draggables = function() {
		_ctr.find('.contract-files-cell, .contract-notes-cell').each(function() {
			let $cell = $(this),
			type = $(this).hasClass('contract-notes-cell') ? 'note' : 'file'
			if (!$cell.data('is-droppable-initialized')) {
				$cell.droppable({
					accept: 'a',
					drop: function(event, ui) {
						$.ajax({
							url: '/fichier/api/',
							type: 'POST',
							data: {
								object_type: 'file',
								file_action: 'contract_' + type,
								contract_id: _ctr.getContractID(),
								file_id: ui.draggable.data('value'),
								attachment_id: ui.draggable.data('attachment'),
							},
							dataType: 'json',
							success: function (response) {
								let $newFile = $('<div class="file-holder" data-file-id="' + ui.draggable.data('attachment') + '"><label class="mb-0"><a href="' + ui.draggable.attr('href') + '" target="_blank">' + ui.draggable.text() + '</a></label><button class="btn btn-sm btn-link btn-action-upload-delete"><span class="material-symbols-outlined">delete</span></button></div>'),
								attachment_id = ui.draggable.data('attachment')
								$newFile.find('.btn-action-upload-delete').on('click', function() {
									swal({
										title: "Êtes-vous certain?",
										text: "Voulez-vous vraiment supprimer ce fichier?",
										type: "warning",
										showCancelButton: true,
										confirmButtonClass: "btn-danger",
										confirmButtonText: "Oui, supprimer le fichier",
										cancelButtonText: "Non",
										closeOnConfirm: true,
										closeOnCancel: true
									},
									function(isConfirm) {
										if (isConfirm) {
											$newFile.fadeOut("fast");
											var request = new FormData();
											request.append("model", 'contract');
											request.append("type", type);
											request.append("action", "delete_file");
											request.append("data", JSON.stringify({
												id : _ctr.getContractID(),
												file_id : attachment_id,
												index: 0,
											}));
											$.slr.db.add(request);
										}
									});
									return false;
								})
								$cell.find('.files').append($newFile)
							},
						})
					},
				});
				$cell.data('is-droppable-initialized', 1)
			}
		})
	}

	_ctr.init_comment_field = function() {
		_ctr.find('textarea[name="note"]').off('change').on('change', function() {
			_ctr.model.item.note = $(this).val();
			_ctr.model.save();
		});
	};

	_ctr.clipboard_contract = function() {
		var input = $('<input type="text">');
		input.val(_ctr.find('.select2-selection__rendered').text());
		$('body').append(input);
		input.select();
		document.execCommand("copy");
		input.remove();
	}

	_ctr.rename_contract = function()
	{
		swal({
			title: "Renommer le contrat",
			text: "Veuillez entrer le numéro de contrat désiré.\nCeci modifiera le contrat partout.",
			type: "input",
			customClass: "rename-contract-swal",
			showCancelButton: true,
			cancelButtonText: 'Annuler',
			confirmButtonClass: "btn-warning",
			confirmButtonText: 'Renommer',
			closeOnConfirm: true,
			inputPlaceholder: "Nouveau numéro"
		}, function (inputValue){
			if (inputValue){
				_ctr.model.rename(inputValue, function(x){
					if (x.success == 1){
						_ctr.interface.select.find('option[value="' + x.item.id + '"]').remove();
						_ctr.interface.select.append($('<option value="' + x.item.id + '">' + x.item.str_id + '</option>').prop("selected", true));
						_ctr.interface.select.change();
					} else {
						// didn't get permission
						swal({
							title: "Erreur",
							text: "Une erreur s'est produite lors du renommage.",
							type: "error",
							confirmButtonClass: "btn-danger"
						});
					}
				});
			}
		});
		$(".rename-contract-swal").find(".form-control").attr("autocomplete", "new-password").css({
			'width' : "200px",
			'margin' : "0 auto 1.5em"
		});
	};

	_ctr.delete_contract = function()
	{
		swal({
			title: "Êtes-vous certain?",
			text: "Voulez-vous vraiment supprimer ce contrat?",
			type: "warning",
			showCancelButton: true,
			confirmButtonClass: "btn-danger",
			confirmButtonText: "Oui, supprimer le contrat",
			cancelButtonText: "Non",
			closeOnConfirm: true,
			closeOnCancel: true
		},
		function(isConfirm) {
			if (isConfirm) {
				_ctr.model.delete(function(x){
					if (x.success == 1){
						_ctr.interface.select.find('option[value="' + x.item.id + '"]').remove();
						_ctr.interface.select.change();
					}
				});
			}
		});
		return false;
	};

	return function()
	{
		// initialize contract selector
		_ctr.interface.select2 = _ctr.interface.select.select2({
			tags: true
		});
		_ctr.interface.select.on("change", _ctr.changed);
		if (_ctr.data("focus-contract") == true){
			_ctr.interface.select.select2('open');
		}

		// do not submit form
		_ctr.form.on("submit", function(){
			return false;
		});

		// init file uploaders
		_ctr.init_contract_uploader();
		_ctr.init_notes_uploader();
		_ctr.init_element_uploader();
		_ctr.init_comment_field();
		_ctr.init_file_draggables();
		_ctr.init_contract_draggables();

		// open in window rather than tab
		_ctr.on('click', '.file-holder a', function() {
			window.open($(this).attr('href'), '_blank', `width=${screen.width * 3/5},height=${screen.height},scrollbars=yes,toolbar=no,location=no`);
			return false
		})

		// init buttons
		_ctr.interface.rename_btn.on("click", _ctr.rename_contract);
		_ctr.interface.delete_btn.on("click", _ctr.delete_contract);
		_ctr.interface.clipboard_btn.on("click", _ctr.clipboard_contract);
		_ctr.interface.next_tab_btn.on("click", function(){
			_ctr.e.reachTab($('body').hasClass('solis') ? 2 : 1);
			return false;
		});

		// init importable rows table
		_ctr.contract_table = _ctr.find("#import-contract-table").ContractTable(_ctr);

		// load model at start
		if (_ctr.interface.select.val() !== "0"){
			var contract_id = parseInt(_ctr.interface.select.val(), 10);
			_ctr.model.get(contract_id);
			_ctr.interface.action_buttons.attr("aria-hidden", "false");
		} else {
			_ctr.uploader.contract.disable();
			_ctr.uploader.notes.disable();
		}
		return _ctr;
	}();
};
